"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _article = require("./article");

Object.keys(_article).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _article[key];
    }
  });
});

var _blog = require("./blog");

Object.keys(_blog).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _blog[key];
    }
  });
});

var _book = require("./book");

Object.keys(_book).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _book[key];
    }
  });
});

var _breadcrumb = require("./breadcrumb");

Object.keys(_breadcrumb).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _breadcrumb[key];
    }
  });
});

var _corporateContact = require("./corporate-contact");

Object.keys(_corporateContact).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _corporateContact[key];
    }
  });
});

var _course = require("./course");

Object.keys(_course).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _course[key];
    }
  });
});

var _faq = require("./faq");

Object.keys(_faq).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _faq[key];
    }
  });
});

var _jsonld = require("./jsonld");

Object.keys(_jsonld).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _jsonld[key];
    }
  });
});

var _localBusiness = require("./local-business");

Object.keys(_localBusiness).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _localBusiness[key];
    }
  });
});

var _logo = require("./logo");

Object.keys(_logo).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _logo[key];
    }
  });
});

var _product = require("./product");

Object.keys(_product).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _product[key];
    }
  });
});

var _sitelinksSearchBox = require("./sitelinks-search-box");

Object.keys(_sitelinksSearchBox).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _sitelinksSearchBox[key];
    }
  });
});

var _socialProfile = require("./social-profile");

Object.keys(_socialProfile).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _socialProfile[key];
    }
  });
});

var _speakable = require("./speakable");

Object.keys(_speakable).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _speakable[key];
    }
  });
});